var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "AccessControlModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal ac-modal",
            title: "Access Control",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.initTables()
            },
          },
        },
        [
          _c(
            "b-tabs",
            {
              staticClass: "ac-tabs",
              attrs: { align: "center", pills: "", card: "" },
            },
            [
              _c(
                "b-tab",
                { attrs: { title: "Access Roles", active: "" } },
                [
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      id: "AccessControlTable",
                      rows: _vm.accessRoles,
                      columns: _vm.accessRolesColumns,
                      config: _vm.config,
                      classes: _vm.classes,
                      actions: _vm.actions,
                    },
                    on: {
                      add: function ($event) {
                        return _vm.initAddRole()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "module_names",
                        fn: function (props) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "module-name-cell",
                                attrs: {
                                  title: _vm.displaySortedModuleNames(
                                    props.row.module_names
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.displaySortedModuleNames(
                                        props.row.module_names
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "isactive",
                        fn: function (props) {
                          return [
                            props.row.isactive
                              ? _c(
                                  "span",
                                  { staticClass: "status-badge status-active" },
                                  [_vm._v("ACTIVE")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "status-badge status-inactive",
                                  },
                                  [_vm._v("INACTIVE")]
                                ),
                          ]
                        },
                      },
                      {
                        key: "modified_date",
                        fn: function (props) {
                          return [
                            _c("span", { staticClass: "date-cell" }, [
                              _vm._v(
                                _vm._s(props.row.modified_date.split("T")[0])
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "update",
                        fn: function (props) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn ac-icon-btn ac-icon-btn--edit",
                                attrs: { disabled: !props.row.isactive },
                                on: {
                                  click: function ($event) {
                                    return _vm.initUpdateRole(props.row)
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: {
                                    icon: ["fas", "pencil-alt"],
                                    size: "lg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "activate",
                        fn: function (props) {
                          return [
                            !props.row.isactive
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn ac-icon-btn ac-icon-btn--activate",
                                    on: {
                                      click: function ($event) {
                                        return _vm.initStatusChangeModal(
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: {
                                        icon: ["fas", "lock-open"],
                                        size: "lg",
                                        title: "Activate Access Role",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn ac-icon-btn ac-icon-btn--deactivate",
                                    on: {
                                      click: function ($event) {
                                        return _vm.initStatusChangeModal(
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: {
                                        icon: ["fas", "lock"],
                                        size: "lg",
                                        title: "Deactivate Access Role",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Organizations" } },
                [
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      id: "organizationsTable",
                      rows: _vm.organizations,
                      columns: _vm.orgColumns,
                      config: _vm.config,
                      classes: _vm.classes,
                      actions: _vm.orgActions,
                    },
                    on: {
                      add: function ($event) {
                        return _vm.initAddOrg()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "updated_at",
                        fn: function (props) {
                          return [
                            props.row.updated_at
                              ? _c("span", { staticClass: "date-cell" }, [
                                  _vm._v(
                                    _vm._s(props.row.updated_at.split("T")[0])
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "update",
                        fn: function (props) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn ac-icon-btn ac-icon-btn--edit",
                                on: {
                                  click: function ($event) {
                                    return _vm.initUpdateOrg(props.row)
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: {
                                    icon: ["fas", "pencil-alt"],
                                    size: "lg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "isactive",
                        fn: function (props) {
                          return [
                            _c(
                              "b-button",
                              {
                                staticClass: "ac-icon-btn",
                                class: props.row.isactive
                                  ? "ac-icon-btn--deactivate"
                                  : "ac-icon-btn--activate",
                                attrs: { variant: "transparent" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeOrgStatusHandler(props.row)
                                  },
                                  mouseover: function ($event) {
                                    _vm.hoveredOrgId = props.row.id
                                  },
                                  mouseleave: function ($event) {
                                    _vm.hoveredOrgId = null
                                  },
                                },
                              },
                              [
                                !props.row.isactive
                                  ? _c("fa", {
                                      attrs: {
                                        icon: [
                                          "fas",
                                          _vm.hoveredOrgId === props.row.id
                                            ? "lock-open"
                                            : "lock",
                                        ],
                                        size: "lg",
                                      },
                                    })
                                  : _c("fa", {
                                      attrs: {
                                        icon: [
                                          "fas",
                                          _vm.hoveredOrgId === props.row.id
                                            ? "lock"
                                            : "lock-open",
                                        ],
                                        size: "lg",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Layers" } },
                _vm._l(_vm.layers, function (layerGroup, index) {
                  return _vm.layers
                    ? _c(
                        "div",
                        { key: layerGroup.project_id },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ac-section-header",
                              on: {
                                click: function ($event) {
                                  return _vm.collapseProject(layerGroup, index)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ac-section-title-row" },
                                [
                                  _c("span", {
                                    staticClass:
                                      "ac-section-dot ac-dot--layers",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "ac-section-title" },
                                    [_vm._v(_vm._s(layerGroup.project))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ac-chevron",
                                  class: { open: layerGroup.collapsed },
                                },
                                [
                                  _c(
                                    "svg",
                                    { attrs: { viewBox: "0 0 24 24" } },
                                    [
                                      _c("polyline", {
                                        attrs: { points: "6 9 12 15 18 9" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              staticClass: "ac-collapse-body",
                              model: {
                                value: layerGroup.collapsed,
                                callback: function ($$v) {
                                  _vm.$set(layerGroup, "collapsed", $$v)
                                },
                                expression: "layerGroup.collapsed",
                              },
                            },
                            _vm._l(
                              layerGroup.part_numbers,
                              function (partNumber, index) {
                                return layerGroup.part_numbers[0].part_number
                                  ? _c(
                                      "div",
                                      { key: partNumber.release_id },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ac-section-header ac-section-header--nested",
                                            on: {
                                              click: function ($event) {
                                                return _vm.collapsePartNumber(
                                                  partNumber
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ac-section-title-row",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "ac-section-dot ac-dot--part",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ac-section-title ac-section-title--sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        partNumber.part_number
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ac-chevron",
                                                class: {
                                                  open: partNumber.collapsed,
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 24 24",
                                                    },
                                                  },
                                                  [
                                                    _c("polyline", {
                                                      attrs: {
                                                        points:
                                                          "6 9 12 15 18 9",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-collapse",
                                          {
                                            staticClass: "ac-collapse-body",
                                            model: {
                                              value: partNumber.collapsed,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  partNumber,
                                                  "collapsed",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "partNumber.collapsed",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "ac-layer-grid" },
                                              _vm._l(
                                                partNumber.layers,
                                                function (layer, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: layer.layer_id,
                                                      staticClass:
                                                        "ac-layer-item",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "ac-checkbox-label",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  layer.visibility,
                                                                expression:
                                                                  "layer.visibility",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "ac-checkbox",
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              value: layer,
                                                              checked:
                                                                Array.isArray(
                                                                  layer.visibility
                                                                )
                                                                  ? _vm._i(
                                                                      layer.visibility,
                                                                      layer
                                                                    ) > -1
                                                                  : layer.visibility,
                                                            },
                                                            on: {
                                                              change: [
                                                                function (
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      layer.visibility,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c =
                                                                      $$el.checked
                                                                        ? true
                                                                        : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        layer,
                                                                      $$i =
                                                                        _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        _vm.$set(
                                                                          layer,
                                                                          "visibility",
                                                                          $$a.concat(
                                                                            [
                                                                              $$v,
                                                                            ]
                                                                          )
                                                                        )
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        _vm.$set(
                                                                          layer,
                                                                          "visibility",
                                                                          $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            )
                                                                        )
                                                                    }
                                                                  } else {
                                                                    _vm.$set(
                                                                      layer,
                                                                      "visibility",
                                                                      $$c
                                                                    )
                                                                  }
                                                                },
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.layerChange(
                                                                    layer,
                                                                    partNumber
                                                                  )
                                                                },
                                                              ],
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass:
                                                              "ac-checkbox-custom",
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ac-layer-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  layer.display_name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          layer.saved &&
                                                          layer.spinner
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ac-layer-status ac-layer-status--saved",
                                                                },
                                                                [
                                                                  _c("fa", {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fas",
                                                                        "check",
                                                                      ],
                                                                      size: "sm",
                                                                    },
                                                                  }),
                                                                ],
                                                                1
                                                              )
                                                            : layer.spinner
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ac-layer-status",
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "spinner-border spinner-border-sm",
                                                                    attrs: {
                                                                      role: "status",
                                                                      "aria-hidden":
                                                                        "true",
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "ac-layer-grid" },
                                      _vm._l(
                                        layerGroup.part_numbers[0].layers,
                                        function (layer, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: layer.layer_id,
                                              staticClass: "ac-layer-item",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "ac-checkbox-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: layer.visibility,
                                                        expression:
                                                          "layer.visibility",
                                                      },
                                                    ],
                                                    staticClass: "ac-checkbox",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      value: layer,
                                                      checked: Array.isArray(
                                                        layer.visibility
                                                      )
                                                        ? _vm._i(
                                                            layer.visibility,
                                                            layer
                                                          ) > -1
                                                        : layer.visibility,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            layer.visibility,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = layer,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                layer,
                                                                "visibility",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                layer,
                                                                "visibility",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            layer,
                                                            "visibility",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "ac-checkbox-custom",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "ac-layer-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          layer.display_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  layer.saved && layer.spinner
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ac-layer-status ac-layer-status--saved",
                                                        },
                                                        [
                                                          _c("fa", {
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "check",
                                                              ],
                                                              size: "sm",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : layer.spinner
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ac-layer-status",
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "spinner-border spinner-border-sm",
                                                            attrs: {
                                                              role: "status",
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c("b-tab", { attrs: { title: "Modules" } }, [
                _c(
                  "div",
                  { staticClass: "ac-module-section" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ac-section-header ac-section-header--tools",
                        on: {
                          click: function ($event) {
                            _vm.toolsCollapsed = !_vm.toolsCollapsed
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ac-section-title-row" }, [
                          _c("span", {
                            staticClass: "ac-section-dot ac-dot--tools",
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ac-section-title" }, [
                            _vm._v("MMP Tools"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "ac-badge ac-badge--tools" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.allModules.filter(
                                    (m) => m.module_type === "tool"
                                  ).length
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ac-chevron",
                            class: { open: _vm.toolsCollapsed },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                              _c("polyline", {
                                attrs: { points: "6 9 12 15 18 9" },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        model: {
                          value: _vm.toolsCollapsed,
                          callback: function ($$v) {
                            _vm.toolsCollapsed = $$v
                          },
                          expression: "toolsCollapsed",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ac-module-grid" },
                          [
                            _vm._l(
                              _vm.allModules.filter(
                                (m) => m.module_type === "tool"
                              ),
                              function (module) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.right",
                                        value: {
                                          title: module.module_description,
                                          customClass: "ac-tooltip",
                                        },
                                        expression:
                                          "{ title: module.module_description, customClass: 'ac-tooltip' }",
                                        modifiers: { hover: true, right: true },
                                      },
                                    ],
                                    key: module.module_name,
                                    staticClass:
                                      "ac-module-chip ac-module-chip--tools",
                                    class: !module.isactive
                                      ? "inactive-module"
                                      : "",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editModule(module)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ac-chip-label" },
                                      [_vm._v(_vm._s(module.module_name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "inactive-tag",
                                        style: {
                                          visibility: module.isactive
                                            ? "hidden"
                                            : "visible",
                                        },
                                      },
                                      [_vm._v("INACTIVE")]
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            !_vm.addingTool
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "ac-module-add-btn w-25",
                                    style: {
                                      borderColor: _vm.moduleTypeColor["tool"],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startAdd("tool")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { viewBox: "0 0 24 24" } },
                                      [
                                        _c("line", {
                                          attrs: {
                                            x1: "12",
                                            y1: "5",
                                            x2: "12",
                                            y2: "19",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "5",
                                            y1: "12",
                                            x2: "19",
                                            y2: "12",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ac-module-chip ac-module-chip--tools ac-module-chip--input",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newToolName,
                                          expression: "newToolName",
                                        },
                                      ],
                                      ref: "toolInput",
                                      staticClass: "ac-chip-input",
                                      attrs: {
                                        autofocus: _vm.addingTool,
                                        placeholder: "New module...",
                                      },
                                      domProps: { value: _vm.newToolName },
                                      on: {
                                        keyup: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return _vm.saveModule("tool")
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "esc",
                                                27,
                                                $event.key,
                                                ["Esc", "Escape"]
                                              )
                                            )
                                              return null
                                            return _vm.cancelAdd("tool")
                                          },
                                        ],
                                        blur: function ($event) {
                                          return _vm.cancelAdd("tool")
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.newToolName = $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ac-module-section" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ac-section-header ac-section-header--features",
                        on: {
                          click: function ($event) {
                            _vm.featuresCollapsed = !_vm.featuresCollapsed
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ac-section-title-row" }, [
                          _c("span", {
                            staticClass: "ac-section-dot ac-dot--features",
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ac-section-title" }, [
                            _vm._v("MMP Features"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "ac-badge ac-badge--features" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.allModules.filter(
                                    (m) => m.module_type === "feature"
                                  ).length
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ac-chevron",
                            class: { open: _vm.featuresCollapsed },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                              _c("polyline", {
                                attrs: { points: "6 9 12 15 18 9" },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        model: {
                          value: _vm.featuresCollapsed,
                          callback: function ($$v) {
                            _vm.featuresCollapsed = $$v
                          },
                          expression: "featuresCollapsed",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ac-module-grid" },
                          [
                            _vm._l(
                              _vm.allModules.filter(
                                (m) => m.module_type === "feature"
                              ),
                              function (module) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.right",
                                        value: {
                                          title: module.module_description,
                                          customClass: "ac-tooltip",
                                        },
                                        expression:
                                          "{ title: module.module_description, customClass: 'ac-tooltip' }",
                                        modifiers: { hover: true, right: true },
                                      },
                                    ],
                                    key: module.module_name,
                                    staticClass:
                                      "ac-module-chip ac-module-chip--features",
                                    class: !module.isactive
                                      ? "inactive-module"
                                      : "",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editModule(module)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ac-chip-label" },
                                      [_vm._v(_vm._s(module.module_name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "inactive-tag",
                                        style: {
                                          visibility: module.isactive
                                            ? "hidden"
                                            : "visible",
                                        },
                                      },
                                      [_vm._v("INACTIVE")]
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            !_vm.addingFeature
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "ac-module-add-btn w-25",
                                    style: {
                                      borderColor:
                                        _vm.moduleTypeColor["feature"],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startAdd("feature")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { viewBox: "0 0 24 24" } },
                                      [
                                        _c("line", {
                                          attrs: {
                                            x1: "12",
                                            y1: "5",
                                            x2: "12",
                                            y2: "19",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "5",
                                            y1: "12",
                                            x2: "19",
                                            y2: "12",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ac-module-chip ac-module-chip--features ac-module-chip--input",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newFeatureName,
                                          expression: "newFeatureName",
                                        },
                                      ],
                                      ref: "featureInput",
                                      staticClass: "ac-chip-input",
                                      attrs: { placeholder: "New module..." },
                                      domProps: { value: _vm.newFeatureName },
                                      on: {
                                        keyup: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return _vm.saveModule("feature")
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "esc",
                                                27,
                                                $event.key,
                                                ["Esc", "Escape"]
                                              )
                                            )
                                              return null
                                            return _vm.cancelAdd("feature")
                                          },
                                        ],
                                        blur: function ($event) {
                                          return _vm.cancelAdd("feature")
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.newFeatureName =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ac-module-section" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ac-section-header ac-section-header--admin",
                        on: {
                          click: function ($event) {
                            _vm.adminCollapsed = !_vm.adminCollapsed
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ac-section-title-row" }, [
                          _c("span", {
                            staticClass: "ac-section-dot ac-dot--admin",
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ac-section-title" }, [
                            _vm._v("MMP Administrative Capabilities"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "ac-badge ac-badge--admin" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.allModules.filter(
                                    (m) => m.module_type === "admin"
                                  ).length
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ac-chevron",
                            class: { open: _vm.adminCollapsed },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                              _c("polyline", {
                                attrs: { points: "6 9 12 15 18 9" },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        model: {
                          value: _vm.adminCollapsed,
                          callback: function ($$v) {
                            _vm.adminCollapsed = $$v
                          },
                          expression: "adminCollapsed",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ac-module-grid" },
                          [
                            _vm._l(
                              _vm.allModules.filter(
                                (m) => m.module_type === "admin"
                              ),
                              function (module) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.right",
                                        value: {
                                          title: module.module_description,
                                          customClass: "ac-tooltip",
                                        },
                                        expression:
                                          "{ title: module.module_description, customClass: 'ac-tooltip' }",
                                        modifiers: { hover: true, right: true },
                                      },
                                    ],
                                    key: module.module_name,
                                    staticClass:
                                      "ac-module-chip ac-module-chip--admin",
                                    class: !module.isactive
                                      ? "inactive-module"
                                      : "",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editModule(module)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ac-chip-label" },
                                      [_vm._v(_vm._s(module.module_name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "inactive-tag",
                                        style: {
                                          visibility: module.isactive
                                            ? "hidden"
                                            : "visible",
                                        },
                                      },
                                      [_vm._v("INACTIVE")]
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            !_vm.addingAdmin
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "ac-module-add-btn w-25",
                                    style: {
                                      borderColor: _vm.moduleTypeColor["admin"],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startAdd("admin")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { viewBox: "0 0 24 24" } },
                                      [
                                        _c("line", {
                                          attrs: {
                                            x1: "12",
                                            y1: "5",
                                            x2: "12",
                                            y2: "19",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "5",
                                            y1: "12",
                                            x2: "19",
                                            y2: "12",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ac-module-chip ac-module-chip--admin ac-module-chip--input",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAdminName,
                                          expression: "newAdminName",
                                        },
                                      ],
                                      ref: "adminInput",
                                      staticClass: "ac-chip-input",
                                      attrs: { placeholder: "New module..." },
                                      domProps: { value: _vm.newAdminName },
                                      on: {
                                        keyup: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return _vm.saveModule("admin")
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "esc",
                                                27,
                                                $event.key,
                                                ["Esc", "Escape"]
                                              )
                                            )
                                              return null
                                            return _vm.cancelAdd("admin")
                                          },
                                        ],
                                        blur: function ($event) {
                                          return _vm.cancelAdd("admin")
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.newAdminName = $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("MMP_UpdateAccessRole", {
        attrs: {
          row: _vm.selectedUpdateRow,
          isUpdate: _vm.isUpdate,
          user: _vm.user,
          allModules: _vm.allModules,
          organizations: _vm.organizations,
        },
        on: {
          refresh: _vm.getRoles,
          refreshUserModules: function ($event) {
            return _vm.$emit("refreshUserModules")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "statusConfirmationModal",
            size: "md",
            "content-class": "menu-bg-blue-transparent-modal sc-modal",
            title: this.selectedUpdateRow.isactive
              ? "Deactivate Role"
              : "Activate Role",
            "hide-footer": "",
          },
        },
        [
          _vm.selectedUpdateRow
            ? _c("div", { staticClass: "ac-confirm-body" }, [
                _c("p", { staticClass: "ac-confirm-text" }, [
                  _vm._v("\n        Role '"),
                  _c("b", { staticClass: "ac-highlight" }, [
                    _vm._v(_vm._s(_vm.selectedUpdateRow.role_name)),
                  ]),
                  _vm._v("' will be set to\n        "),
                  _c("b", { staticClass: "ac-highlight" }, [
                    _vm._v(
                      _vm._s(
                        _vm.selectedUpdateRow.isactive ? "INACTIVE" : "ACTIVE"
                      )
                    ),
                  ]),
                  _vm._v(".\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ac-confirm-actions" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.changeStatus },
                      },
                      [_vm._v("Confirm")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "orgStatusChangeModal",
            size: "md",
            "content-class": "menu-bg-blue-transparent-modal oc-modal",
            title: this.selectedOrg.isactive
              ? "Deactivate Organization"
              : "Activate Organization",
            "hide-footer": "",
          },
        },
        [
          _vm.selectedOrg
            ? _c("div", { staticClass: "ac-confirm-body" }, [
                _c("p", { staticClass: "ac-confirm-text" }, [
                  _vm._v("\n        Organization '"),
                  _c("b", { staticClass: "ac-highlight" }, [
                    _vm._v(_vm._s(_vm.selectedOrg.company_name)),
                  ]),
                  _vm._v("' will be set to\n        "),
                  _c("b", { staticClass: "ac-highlight" }, [
                    _vm._v(
                      _vm._s(_vm.selectedOrg.isactive ? "INACTIVE" : "ACTIVE")
                    ),
                  ]),
                  _vm._v(".\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ac-confirm-actions" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.changeOrgStatus },
                      },
                      [_vm._v("Confirm")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("MMP_OrganizationsModal", {
        attrs: { company: _vm.selectedCompany },
        on: { refresh: _vm.initTables },
      }),
      _vm._v(" "),
      _c("MMP_Modules", {
        attrs: { updateModule: _vm.updateModule, newModule: _vm.newModule },
        on: {
          removeNewModule: function ($event) {
            return _vm.removeNewModule($event)
          },
          resetModules: function ($event) {
            return _vm.getAllModules()
          },
          refreshUserModules: function ($event) {
            return _vm.$emit("refreshUserModules")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }